export default function initTapBar()
{
    document.querySelectorAll('.js-toggle-catalog-menu').forEach(button => {

        button.addEventListener('click', () => {
            button.classList.toggle('tapbar__item_active');
            document.querySelector('#catalog-navigation').classList.toggle('menu__catalog_fixed');
            document.body.classList.toggle('overflowed');
        });
    });
}
